const apiRequest = async (endpoint: string, options: RequestInit = {}) => {
	const headers: Record<string, string> = {
		"Content-Type": "application/json",
		...(window?.pumpSizingVerify?.nonce_verification_enabled === "true" && {
			"X-WP-Nonce": window?.pumpSizingVerify?.nonce || "",
		}),
	};

	const response = await fetch(endpoint, {
		...options,
		headers: {
			...headers,
			...(options.headers as Record<string, string>),
		},
		credentials: "same-origin",
	});

	if (!response.ok) {
		const body = await response.json().catch(() => null);
		const message =
			typeof body?.message === "string" && body.message.trim() !== ""
				? body.message
				: `Request failed (${response.status}). Please try again.`;

		throw new Error(message);
	}

	switch (response.headers.get("Content-Type")) {
		case 'application/pdf':
			return response.blob();
		case 'application/json':
		default:
			return response.json();
	}
};

export default apiRequest;
